import dayjs from "dayjs";
import type { GroupedMessages, MessageType } from "../types/chat.types";

export const formatTimestamp = (isoDate: string) =>
  dayjs(isoDate).format("h:mm A");

const formatDateLabel = (isoDate: string) => {
  const date = dayjs(isoDate);
  const today = dayjs();
  if (date.isSame(today, "day")) return "Today";
  if (date.isSame(today.subtract(1, "day"), "day")) return "Yesterday";
  return date.format("dddd, MMM D");
};

export const groupMessagesByDate = (
  messages: MessageType[],
): GroupedMessages[] => {
  if (!messages.length) return [];

  const sorted = [...messages].sort((a, b) =>
    dayjs(a.createdAt).diff(dayjs(b.createdAt)),
  );

  const groups = sorted.reduce<Record<string, MessageType[]>>(
    (acc, message) => {
      const label = formatDateLabel(message.createdAt);
      if (!acc[label]) {
        acc[label] = [];
      }
      acc[label].push(message);
      return acc;
    },
    {},
  );

  return Object.entries(groups).map(([dateLabel, items]) => ({
    dateLabel,
    items,
  }));
};


